import {
  Backdrop,
  Box,
  CircularProgress,
  Grid,
  IconButton,
  ListItem,
  Typography,
  useTheme,
} from "@mui/material";
import { CiFileOn } from "react-icons/ci";
import { Enumerations } from "../../config/Enumerations";
import { VscOpenPreview } from "react-icons/vsc";
import { LiaDownloadSolid } from "react-icons/lia";
import { AppEntryAttachmentsRepository } from "../repositories/AppEntryAttachmentsRepository";
import React from "react";
import PDFDialogViewer from "../common/PdfDialogViewer";
import { useDispatch } from "react-redux";
import { notifyShowErrorMessage } from "../../store/AlertSlice";
import { ErrorMessageResolver } from "../common/ErrorMessageResolver";
import { SETTINGS } from "../../Settings";

export default function EntryOtherDocuments({ otherDocuments, appEntry }) {
  const theme = useTheme();
  const [previewPdf, setPreviewPdf] = React.useState(null);
  const [saving, setSaving] = React.useState(false);
  const [imagePreview, setImagePreview] = React.useState(null);
  const [dwgPreview, setDwgPreview] = React.useState(null);
  const dispatch = useDispatch();

  const previewAttachment = (attachment) => {
    console.log(attachment);
    AppEntryAttachmentsRepository.getAttachment(attachment.id).then(
      (response) => {
        const file = new Blob([response.data], { type: response.data.type });
        if (attachment.fileType === "application/pdf") {
          setPreviewPdf(file);
        }
        if (attachment.fileType.startsWith("image/")) {
          setImagePreview(URL.createObjectURL(file));
        }
        // TODO: implement DWG preview
        // if (
        //   attachment.fileType.startsWith("application/octet-stream") &&
        //   attachment.fileName.endsWith(".dwg")
        // ) {
        //   setDwgPreview(URL.createObjectURL(file));
        //   window.open(
        //     "https://sharecad.org/cadframe/load?url=" +
        //       URL.createObjectURL(file),
        //     "_blank"
        //   );
        // }
      }
    );
  };

  const downloadAttachment = (attachment) => {
    setSaving(true);
    const url = `${SETTINGS.EXTERNAL_API_URL}external/appEntries/attachments/${
      attachment?.id
    }?token=${localStorage.getItem("accessToken")}`;

    console.log("Downloading from URL:", url);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", attachment?.fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setSaving(false);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} className="other-documents-container">
        <div className={`other-documents-header no-bottom-padding`}>
          <div className="other-documents-title-container">
            <div className="other-documents-title">
              <Typography variant="h6" className="title-text">
                Останати документи
              </Typography>
              <Typography
                variant="caption"
                className="document-count"
                style={{ backgroundColor: theme.palette.primary.main }}
              >
                {otherDocuments?.length}
              </Typography>
            </div>
          </div>
        </div>
        {otherDocuments?.length > 0 && (
          <Box className="other-documents-box">
            {otherDocuments?.map((attachment, index) => (
              <ListItem key={index} className="document-item dark-border">
                <div className="document-icon">
                  <CiFileOn color="#2d2d2d" size={25} />
                </div>
                <div className="document-details">
                  <Typography variant="inherit" className="document-type dark">
                    {Enumerations.DocumentType[attachment.documentType] ||
                      attachment.type}
                  </Typography>
                  <Typography variant="inherit" className="document-name dark">
                    {attachment.fileName}
                  </Typography>
                </div>
                <div className="document-actions">
                  <IconButton
                    className="document-icon-button"
                    onClick={() => downloadAttachment(attachment)}
                  >
                    <LiaDownloadSolid color="#2d2d2d" />
                  </IconButton>
                </div>
              </ListItem>
            ))}
          </Box>
        )}
      </Grid>

      {saving && (
        <Backdrop open={true} sx={{ zIndex: 9999, color: "#fff" }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </Grid>
  );
}
